<template>
  <!-- PERBAIKAN: Mengubah :value menjadi :visible dan menangkap event @hidden -->
  <b-modal
    :visible="value"
    @hidden="$emit('input', false)"
    title="Detail Rincian Tagihan & Pembayaran Pelanggan"
    title-class="font-weight-bold text-dark"
    size="xl"
    centered
    hide-footer
    no-close-on-backdrop
  >
    <!-- Header Informasi Proyek -->
    <div class="mb-3 p-3 bg-light rounded border row mx-0">
      <div class="col-sm-6">
        <h6 class="mb-1 font-weight-bold">
          Nama Proyek: <span class="text-primary">{{ projectName }}</span>
        </h6>
        <small class="text-muted d-block">Kode Proyek: {{ projectCode }}</small>
      </div>
    </div>

    <!-- State Loading -->
    <div v-if="loading" class="text-center my-5">
      <b-spinner variant="primary" label="Memuat data..."></b-spinner>
      <p class="text-muted mt-2">Sedang mengambil riwayat tagihan...</p>
    </div>

    <!-- State Data Kosong -->
    <div
      v-else-if="!dataRows || dataRows.length === 0"
      class="text-center my-4"
    >
      <p class="text-muted">Tidak ada riwayat data tagihan untuk proyek ini.</p>
    </div>

    <!-- Tampilan Tabel Riwayat Tagihan -->
    <div v-else class="table-responsive">
      <table class="table table-sm table-bordered custom-table-modal mb-0">
        <thead>
          <tr class="text-center text-nowrap">
            <th width="5%">No</th>
            <th>No. Faktur</th>
            <th>Periode Tagihan</th>
            <th>Nominal Tagihan</th>
            <th>Beban Vendor (SPH)</th>
            <th>Tanggal Ditagih</th>
            <th>Tanggal Bayar</th>
            <th>Status Finansial</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tagihan, idx) in dataRows" :key="idx">
            <td class="text-center">{{ tagihan.no_tagihan }}</td>
            <td class="text-center font-weight-bold">#####</td>
            <td class="text-center text-nowrap">
              {{ dateFormat(tagihan.tanggal_awal) }} s/d
              {{ dateFormat(tagihan.tanggal_akhir) }}
            </td>
            <td class="text-right text-success font-weight-medium">
              {{ formatRupiah(tagihan.total_tagihan) }}
            </td>
            <td class="text-right text-danger">
              {{ formatRupiah(tagihan.beban_sph_vendor) }}
            </td>
            <td class="text-center">{{
              dateFormat(tagihan.tanggal_ditagih)
            }}</td>
            <td class="text-center">{{ dateFormat(tagihan.tanggal_bayar) }}</td>
            <td class="text-center">
              <span :class="badgeClass(tagihan.status_pembayaran)">
                {{ tagihan.status_pembayaran }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Tombol Tutup Manual -->
    <div class="text-right mt-3 border-top pt-3">
      <b-button variant="secondary" @click="$emit('input', false)"
        >Tutup</b-button
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TagihanModal',
  props: {
    value: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    projectName: { type: String, default: '' },
    projectCode: { type: String, default: '' },
    dataRows: { type: Array, default: () => [] },
    formatRupiah: { type: Function, required: true },
    dateFormat: { type: Function, required: true },
  },
  methods: {
    badgeClass(status) {
      if (status === 'LUNAS DIBAYAR') return 'badge badge-success px-2 py-1'
      if (status === 'SUDAH DITAGIHKAN')
        return 'badge badge-warning px-2 py-1 text-dark'
      return 'badge badge-secondary px-2 py-1'
    },
  },
}
</script>
